import React from 'react'
import s from "../../general.module.scss";

export const Rub = () => <span className={ s.rub }>руб.</span>
